import { JourneyInterestContainer } from "components/views/fle/journey/JourneyInterestContainer"
import Interests from "utils/Interests"
import React from "react"

const JourneyNextStepInterest = ({ history, toDone }) => {
  return (
    <JourneyInterestContainer
      title="Which next step would you like to take?"
      toDone={toDone}
      somethingElseNext="/fle/journey/next-step/something-else"
      history={history}
      interestsToExclude={[Interests.INITIAL_FERTILITY_TESTING, Interests.PREGNANCY]}
    />
  )
}

export { JourneyNextStepInterest }
